import { useState, useEffect } from "react";
import { Modal, Input, Button, Switch, Form, ConfigProvider } from "antd";
import ValidatorUtils from "../../../utils/ValidatorUtils";
import "../less/_main-dir.less";


// service
import SettingsService from "../../../services/api/SettingsService";


// ─── Services ──────────────────────────────────────────────────
const settingService = new SettingsService();

// AP-5899: antd's default input border / placeholder / switch-off colors are too
// faint and the IP field disappears on dimmed (battery) screens. Darken them here.
const printerTheme = {
  token: {
    colorBorder: "#8c8c8c",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.55)",
    colorBgContainerDisabled: "#f0f0f0",
  },
  components: {
    Switch: {
      colorTextQuaternary: "rgba(0, 0, 0, 0.45)",
      colorTextTertiary: "rgba(0, 0, 0, 0.65)",
    },
  },
};

const PrinterSettingsView = (props: any) => {
  let [form] = Form.useForm();
  const [bluetooth, setBluetooth] = useState(true);
  const [value, setValue] = useState<any>(null);
  const [settings_id, setSettingsID] = useState<any>();

  useEffect(() => {
    const initialize = async () => {
      if (props.visible) {
        let result = await settingService.getSettings();
        if (result._id) {
          setSettingsID(result._id);
        }
        if (result.printer_settings && result.printer_settings.ip) {
          setBluetooth(false);
          form.setFieldsValue({ ip: result.printer_settings.ip });
        } else {
          setBluetooth(true);
        }
      }
    };
    initialize();
  }, [props.visible]);

  const onCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  const onSubmitSuccess = async () => {
    let settings = await form.validateFields();
    if (settings_id) {
      await settingService.editPrinterSettings(settings, settings_id);
      props.onCancel();
    }
  };

  const handleBluetoothChange = async (bluetooth: any) => {
    if (bluetooth!) {
      if (settings_id) {
        let settings = { ip: "" };
        await settingService.editPrinterSettings(settings, settings_id);
      }
    }
    form.resetFields();
    setBluetooth(bluetooth);
  };

  const onChange = (evt: any) => {
    setValue(evt.target.value);
  };

  return (
    <div>
      <Modal
        forceRender
        title="Printer Settings"
        open={props.visible}
        centered
        className="form_modal"
        onCancel={onCancel}
        width={550}
        footer={null}
        mask={{ closable: false }}
      >
        <ConfigProvider theme={printerTheme}>
        <div>
          <label style={{ marginRight: "5px" }}>Bluetooth: </label>
          <Switch checked={bluetooth} onChange={handleBluetoothChange} />
          <div className="print_main_div">
            <Form form={form} onFinish={onSubmitSuccess} className="print_main_div">
              <Form.Item
                name="ip"
                rules={[
                  { required: true, message: "IP Address is required." },
                  ({ }) => ({
                    validator(_rule, value) {
                      if (value && !ValidatorUtils.checkIPAddress(value)) {
                        return Promise.reject("Invalid Data.");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                className="form-item-bottom"
              >
                <Input
                  className="printer_input"
                  placeholder="Printer's IP Address: eg. 192.168.22.10"
                  disabled={bluetooth}
                  style={{ marginTop: "10px" }}
                  onChange={onChange}
                  value={value}
                  maxLength={20}
                />
              </Form.Item>
              <Form.Item className="form-item-bottom">
                <Button
                  htmlType="submit"
                  className="antd-btn antd-btn-primary printer_button"
                  disabled={bluetooth}
                >
                  Apply
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        </ConfigProvider>
      </Modal>
    </div>
  );
};

export default PrinterSettingsView;